import { LineOpacityType } from 'root/model/route/Route';

export const convertTransparencyToOpacity = (value: LineOpacityType): LineOpacityType => {
    return (Math.round((1 - value) * 10) / 10) as LineOpacityType;
};
